{
  "Add a new card": "Añadir una nueva tarjeta",
  "Add a new ACH account": "Añadir una nueva cuenta ACH",
  "Bank": "Banco",
  "Visa": "Visa",
  "Mastercard": "Mastercard",
  "Discover": "Discover",
  "Amerian Express": "American Express",
  "Auto-Pay On": "Pago automático activado",
  "Auto-Pay Off": "Pago automático desactivado",
  "Payment Method Missing": "Método de pago faltante",
  "Home": "Inicio",
  "Reserve": "Reservar",
  "Menu & Events": "Menú y Eventos",
  "Billing": "Facturación",
  "Sign Out": "Cerrar sesión",
  "Issued Date": "Fecha de emisión",
  "Invoice Number": "Número de factura",
  "Description": "Descripción",
  "Invoice Payment Amount": "Monto de pago de la factura",
  "Due Date": "Fecha de vencimiento",
  "Status": "Estado",
  "invoiceEmptyState": "Actualmente no tienes ninguna factura pendiente aquí.",
  "Payment Due": "Pago vencido",
  "Late": "Atrasado",
  "Paid": "Pagado",
  "Processing": "Procesando",
  "Failed": "Fallido",
  "Voided": "Anulado",
  "Member Benefits": "Beneficios para miembros",
  "Meeting Room": "Sala de reuniones",
  "Office": "Oficina",
  "Desk": "Escritorio",
  "Open Workspace": "Espacio de trabajo abierto",
  "New": "Nuevo",
  "Your Profile": "Tu perfil",
  "Company Profile": "Perfil de la empresa",
  "Member Management": "Gestión de miembros",
  "FAQ": "Preguntas frecuentes",
  "Notification Settings": "Configuración de notificaciones",
  "Refer a Friend": "Recomendar a un amigo",
  "beta": "beta",
  "Something Went Wrong": "Algo salió mal",
  "Page Not Found": "Página no encontrada",
  "Please refresh the page and try again.": "Por favor, actualiza la página e inténtalo de nuevo.",
  "Please try our home page.": "Por favor, prueba nuestra página de inicio.",
  "Refresh": "Actualizar"
}
